// extracted by mini-css-extract-plugin
export default {"container":"rK-z","topReviewHeading":"sK-z","criticalReview":"tK-z","favorableReview":"uK-z","vsSeparator":"vK-z"};